import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { Router } from '@angular/router';

import { AuthService } from '@services/api/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) {}

  intercept(
      req: HttpRequest<any>,
      next: HttpHandler
  ): Observable<HttpEvent<any>> {
      const profile = this.authService.profile;

      if (profile?.expireAt && new Date(profile.expireAt) <= new Date()) {
          this.authService.logout();
          this.router.navigateByUrl('/login');
          return EMPTY;
      }

      // Send cookies automatically with every request
      req = req.clone({ withCredentials: true });
      return next.handle(req);
  }

}
